import * as t from 'io-ts'

export const AssetPropertiesIO = t.intersection([
  t.type({
    asset_id: t.string,
    resource_type: t.string,
    resource_id: t.string,
    creation_user: t.string,
    creation_time: t.number,
    content_type: t.string,
    filename: t.string,
    filesize: t.number,
    // app_id: t.string,
    // asset_type: t.string,
  }),
  t.partial({
    expiry: t.number,
    expiry_time: t.number,
    compression_type: t.string,
    compressed_size: t.number,
  }),
])
export type AssetPropertiesT = t.TypeOf<typeof AssetPropertiesIO>

export type AssetOptions = {
  compressed?: boolean
  ignore_expiry?: boolean
  attachment?: boolean
}

export type GetAssetUrlQuery = (options?: AssetOptions | undefined) => string
